import { Icon, Tooltip } from '@mui/material';
import { JustificationBase } from '@schooly/api';
import { FC } from 'react';

import {
  JustificationContent,
  JustificationEmptyTextIds,
  PendingJustificationNote,
} from './JustificationContent';
import { getJustificationStatusIcon, getJustificationStatusPalette } from './utils';

type JustificationInfoProps = {
  justification: JustificationBase;
  pendingNote?: PendingJustificationNote;
  canViewStudents?: boolean;
  relationId?: string;
  emptyTextIds?: JustificationEmptyTextIds;
};

export const JustificationInfo: FC<JustificationInfoProps> = ({
  justification,
  pendingNote,
  canViewStudents,
  relationId,
  emptyTextIds,
}) => {
  const { status } = justification;
  const palette = getJustificationStatusPalette(status);
  const icon = getJustificationStatusIcon(status);

  return (
    <Tooltip
      title={
        <JustificationContent
          justification={justification}
          pendingNote={pendingNote}
          canViewStudents={canViewStudents}
          relationId={relationId}
          emptyTextIds={emptyTextIds}
          sx={{ maxHeight: 350 }}
        />
      }
      componentsProps={{ tooltip: { sx: { p: 1.25, minWidth: 250 } } }}
    >
      <Icon sx={{ color: palette.icon }}>{icon}</Icon>
    </Tooltip>
  );
};
